import { render, staticRenderFns } from "./VirtualList.vue?vue&type=template&id=31464eec&scoped=true"
import script from "./VirtualList.vue?vue&type=script&lang=js"
export * from "./VirtualList.vue?vue&type=script&lang=js"
import style0 from "./VirtualList.vue?vue&type=style&index=0&id=31464eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31464eec",
  null
  
)

export default component.exports